import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from 'src/app/services/notification.service';
import { SigningService } from 'src/app/services/signing.service';

@Component({
    selector: 'document-signing-request-confirmation',
    templateUrl: './document-signing-request-confirmation.component.html',
    styleUrls: ['./document-signing-request-confirmation.component.scss'],
    standalone: false
})
export class DocumentSigningRequestConfirmationComponent implements OnInit {

  constructor(private readonly _signingService: SigningService,
    private readonly _notifyService: NotificationService,
    private readonly _activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    // Vendors that do not return the DocuSign callback parameters cannot be confirmed from here:
    // the host dialog owns the order id and the view that was opened, so it makes the call instead.
    // The vendor is only known once the order has been created, so a return that carries no envelope
    // id is handed up regardless of which return route the dialog picked.
    const hasVendorCallbackParams = !!new URLSearchParams(location.search).get('envelopeId');
    if (this._activatedRoute.snapshot.data['passReturnParamsToParent'] || !hasVendorCallbackParams) {
      // The parent dialog is served from this same admin origin, so target it explicitly
      // instead of '*' to avoid leaking the signing return parameters to any embedding window.
      window.parent.postMessage({
        documentSigningReturnParams: location.search
      }, window.location.origin);
      return;
    }

    this.sendConfirmation();
  }

  sendConfirmation = () => {
    let urlParams = location.search;

    urlParams = urlParams.replace('?t', '?token');
    urlParams = urlParams.replace('event', 'action');

    this._signingService.onSenderViewSubmitted(urlParams).subscribe((response) => {
      window.parent.postMessage({
        shouldCloseDocSignIframe: true,
        response: response
      }, window.location.origin);
    }, (err) => {
      this._notifyService.showError(err.message || err || "Send Document for Signing", "Error");
    })
  }

}
